import React, { useEffect, useState } from "react";
import { useForm, useFieldArray } from "react-hook-form";

const NcAssementModal = ({
  isOpen,
  onClose,
  onSave,
  editingData,
}) => {
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm();

 
  useEffect(() => {
    if (editingData) {
      reset(editingData);
    }
  }, [editingData, reset]);


  const onSubmit = (data) => {
    console.log("Complete Data:", data);
    onSave(data);
    reset();
    onClose();
  };



  return (
    <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white w-2/4 max-h-[80vh] overflow-y-auto rounded-lg shadow-lg p-6">
        <h2 className="text-2xl font-semibold mb-4">
          Add Nc Assesment
        </h2>

        <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
          <div className="grid grid-cols-2 gap-6">
            <div>
              <label className="block mb-1 font-medium">
                Survey Name
              </label>
              <input
                {...register("surveyName", {
                  required: "This field is required",
                })}
                className="w-full border border-gray-300 p-2 rounded"
                placeholder="Enter survey name"
              />
              {errors.feeStructureName && (
                <p className="text-red-500">
                  {errors.feeStructureName.message}
                </p>
              )}
            </div>
            <div className="">
              <label className="block mb-1 font-medium">Objective</label>
              <input
                {...register("objective")}
                className="w-full border border-gray-300 p-2 rounded"
                placeholder="Enter objectives"
              />
            </div>
            <div>
              <label className="block mb-1 font-medium">Select audience</label>
              <select
                className="w-full border border-gray-300 rounded p-2"
                {...register("audience")}
              >
                <option>Parent</option>
                <option>Teacher</option>
                <option>Learner</option>
              </select>
            </div>
            <div>
              <label className="block mb-1 font-medium">Select Campus</label>
              <select
                className="w-full border border-gray-300 rounded p-2"
                {...register("campus")}
              >
                <option>A</option>
                <option>B</option>
                <option>C</option>
              </select>
            </div>
            <div>
              <label className="block mb-1 font-medium">Select Class</label>
              <select
                className="w-full border border-gray-300 rounded p-2"
                {...register("cls")}
              >
                <option>X</option>
                <option>Y</option>
                <option>Z</option>
              </select>
            </div>
          </div>
          <div className="flex justify-end space-x-4 mt-6">
            <button
              type="button"
              onClick={onClose}
              className="bg-gray-400 text-white px-6 py-2 rounded"
            >
              Close
            </button>
            <button
              type="submit"
              className="bg-[#241763] text-white px-6 py-2 rounded"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NcAssementModal;

